import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { AuthGuard } from "../services/auth.guard";
import { ContactsComponent } from "./contacts.component";
import { CreateContactModalComponent } from "./create-contact-modal/create-contact-modal.component";

const contactsRoutes: Routes = [
    {
        path: "contacts",
        component: ContactsComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "contacts(modal:create-contact)",
        component: CreateContactModalComponent,
        outlet: "modal",
        canActivate: [AuthGuard],
    },
    {
        path: "create-contact",
        component: CreateContactModalComponent,
        outlet: "modal",
        canActivate: [AuthGuard],
    },
];

@NgModule({
    imports: [RouterModule.forChild(contactsRoutes)],
    exports: [RouterModule],
})
export class ContactsRoutingModule {}
